// components/ui/app-breadcrumb.tsx
"use client";

import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { cn } from "@/lib/utils";

type BreadcrumbItemType = {
  label: string;
  href?: string;
  isCurrent?: boolean;
};

interface AppBreadcrumbProps {
  items: BreadcrumbItemType[];
  className?: string;
  title?: string;
  isHero?: boolean;
}

export function AppBreadcrumb({
  items,
  className,
  title,
  isHero,
}: AppBreadcrumbProps) {
  return (
    <div
      className={cn(
        { "bg-primary/10 p-3": !isHero, "mt-2": isHero },
        className,
      )}
    >
      <div
        className={cn(
          "custom-container flex flex-wrap gap-5",
          isHero ? "justify-center" : title ? "justify-between" : "justify-end",
        )}
      >
        {title && (
          <h2 className="hidden md:block text-primary font-semibold">
            {title}
          </h2>
        )}
        <Breadcrumb>
          <BreadcrumbList>
            {items.map((item, idx) => (
              <BreadcrumbItem key={idx}>
                {item.isCurrent ? (
                  <BreadcrumbPage className={cn(isHero && "text-gray-200")}>
                    {item.label}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink
                    className={cn(isHero && "text-gray-200")}
                    href={item.href}
                  >
                    {item.label}
                  </BreadcrumbLink>
                )}
                {idx < items.length - 1 && (
                  <BreadcrumbSeparator
                    className={cn(isHero && "text-gray-200")}
                  />
                )}
              </BreadcrumbItem>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </div>
  );
}
